import {IState} from "@/interfaces/IState";

export const timer = {
    state: {
        timeRemaining: 0,
        dateRemaining: {},
        time: 0,
        endTime: false,
        timeEndRemainingZero: false
    },
    mutations: {
        SET_TIME(state: IState, payload: any) {
            state.time = payload.time;
        },
        SET_END_TIME(state: IState, payload: any) {
            state.endTime = payload;
        },
        SET_TIME_REMAINING(state: IState, payload: any) {
            state.timeRemaining = payload;
        },
        SET_DATE_REMAINING(state: IState, payload: any) {
            state.dateRemaining = payload;
        },
        SET_TIME_END_REMAINING_ZERO(state: IState, payload: any) {
            state.timeEndRemainingZero = payload;
        }
    },
    actions: {
        setTime(context: any, payload: any) {
            context.commit("SET_TIME", payload);
        },
        setEndTime(context: any, payload: any) {
            context.commit("SET_END_TIME", payload)
        },
        setTimeRemaining(context: any, payload: any) {
            context.commit("SET_TIME_REMAINING", payload);
        },
        setDateRemaining(context: any, payload: any) {
            context.commit("SET_DATE_REMAINING", payload);
        },
        setTimeEndRemainingZero(context: any, payload: any) {
            context.commit("SET_TIME_END_REMAINING_ZERO", payload);
        },
        resetTimer(context: any, payload: any){
            context.commit("SET_TIME", { time: 0 });
            context.commit("SET_END_TIME", false)
            context.commit("SET_TIME_REMAINING", 0);
            context.commit("SET_DATE_REMAINING", {});
            context.commit("SET_TIME_END_REMAINING_ZERO", false);
        }
    },
    getters: {
        getTime(state: IState) {
            return state.time;
        },
        getEndTime(state: IState) {
            return state.endTime;
        },
        getTimeRemaining(state: IState) {
            return state.timeRemaining;
        },
        getDateRemaining(state: IState) {
            return state.dateRemaining;
        },
        getTimeEndRemainingZero(state: IState) {
            return state.timeEndRemainingZero;
        }
    }
}